import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    tooltip: {
      padding: theme.spacing(0),
      backgroundColor: COLORS.neutral.white,
      boxShadow: theme.shape.boxShadowMedium,
      border: theme.shape.borderGray70,
      borderRadius: theme.shape.borderRadius,
    },
    title: {
      display: 'flex',
      flexFlow: 'column nowrap',
      gap: theme.spacing(1),
      padding: theme.spacing(1.5),
    },
    image: {
      maxWidth: '100%',
      '&:not($loaded)': {
        display: 'none',
      },
    },
    loaded: {},
    buttonLabel: {
      maxWidth: '100%',
      display: 'inline',

      '& span': {
        ...theme.typography.regular12,
        textDecoration: 'underline',
        textAlign: 'left',
        color: COLORS.gray.black,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        wordWrap: 'break-word',
      },
    },
  }),
  { name: 'ResourceThumbnailTooltip' }
);
